import React from 'react';
import '../styles/footer.css';

function Footer () {
    return (

<footer className="footerArea">
    <div>
<a className="footerLink" href="https://github.com/stessman" target="_blank" rel="noreferrer">GitHub</a>
<a className="footerLink" href="https://www.linkedin.com/in/scott-tessman-8b7210a6/" target="_blank" rel="noreferrer">LinkedIn</a>
<a className="footerLink" href="https://stackoverflow.com/users/16894025/stessman" target="_blank" rel="noreferrer">Stack Overflow</a>
</div>
</footer>

    );
}

export default Footer;